import { SelectOption } from '@admin/app/models'
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Controller, FieldValues, FormState, UseControllerProps } from 'react-hook-form'

export type AllSelectOption = 'All'

type FieldProps = Pick<SelectProps, 'disabled' | 'multiple' | 'size'>

interface Props<T extends FieldValues> extends UseControllerProps<T>, FieldProps {
  formState: FormState<T>
  label: string
  fullWidth?: boolean
  allOption?: boolean
  options: SelectOption[]
  required?: boolean
}

export const ControlledSelect = <T extends FieldValues>({
  name,
  control,
  label,
  disabled,
  multiple,
  fullWidth,
  options,
  size,
  required = false,
  allOption,
  formState: { errors },
}: Props<T>) => {
  const { t } = useTranslate()

  return (
    <FormControl required={required} fullWidth={fullWidth ?? true}>
      <InputLabel>{label}</InputLabel>
      <Controller
        control={control}
        name={name}
        rules={{ required: required ? t('fieldRequired', 'This field is required') : false }}
        render={({ field }) => (
          <Select
            {...field}
            required={required}
            error={!!errors[name]}
            size={size}
            multiple={multiple}
            disabled={disabled}
            label={label}
          >
            {allOption && <MenuItem value='All'>{t('All', 'All')}</MenuItem>}
            {options.map(({ value, label }) => (
              <MenuItem key={label} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        )}
      />
      {errors[name] && (
        <FormHelperText error={!!errors[name]}>{errors[name]?.message as string}</FormHelperText>
      )}
    </FormControl>
  )
}
